export default "__VITE_ASSET__BjLNowrM__ 288w, __VITE_ASSET__DRKmzwnP__ 432w, __VITE_ASSET__CHxKJWNS__ 576w";